module.exports = __webpack_public_path__ + "img/职业药师 在线咨询.c68376d4.png";